import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box, Container, Menu, MenuItem } from "@mui/material";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import { LAYOUT } from "../../configuration/theme";

const SORT_OPTIONS = [
    { value: "views", label: "Most popular" },
    { value: "most_recent", label: "Most recent" },
    { value: "creator_name", label: "Creator name" },
    { value: "with_video", label: "With video" },
];

const countLabel = (total) => {
    if (total === "-" || total === null || total === undefined) return "";
    return `${total} ${Number(total) === 1 ? "post" : "posts"}`;
};

const FeedToolbar = ({ total = 0, sort = "most_recent", category = "", onSortChange, onClearCategory }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const activeCategory = ConfigurationHelper.getCategories().find((option) => option.value === category);
    const activeSort = SORT_OPTIONS.find((option) => option.value === sort) || SORT_OPTIONS[1];

    const pick = (value) => {
        setAnchorEl(null);
        if (value !== sort) {
            onSortChange(value);
        }
    };

    return (
        <Container sx={{ px: LAYOUT.pagePad, pt: "22px", pb: "20px" }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    paddingTop: "14px",
                    borderTop: "1px solid #F1EAE6",
                }}
            >
                {activeCategory && (
                    <Box
                        component="button"
                        type="button"
                        onClick={onClearCategory}
                        sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            cursor: "pointer",
                            backgroundColor: "#1A1A1A",
                            color: "#fff",
                            border: 0,
                            borderRadius: "999px",
                            height: "32px",
                            padding: "0 14px",
                            fontSize: "12.5px",
                            fontWeight: 600,
                        }}
                    >
                        {activeCategory.label}
                        <Box component="span" sx={{ fontSize: "13px", lineHeight: 1 }}>
                            &times;
                        </Box>
                    </Box>
                )}
                <Box component="span" sx={{ fontSize: "13px", color: "#7A736E" }}>
                    {countLabel(total)}
                </Box>
                <Box
                    component="button"
                    type="button"
                    data-testid="feed-toolbar-sort"
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    sx={{
                        marginLeft: "auto",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                        backgroundColor: "#fff",
                        border: "1px solid #DED5CF",
                        borderRadius: "999px",
                        height: "38px",
                        padding: "0 16px",
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#1A1A1A",
                        transition: "border-color 130ms ease",
                        "&:hover": { border: "1px solid #1A1A1A", backgroundColor: "#fff", color: "#1A1A1A" },
                    }}
                >
                    <Box component="span" sx={{ color: "#7A736E", fontWeight: 500 }}>
                        Sort by:
                    </Box>
                    {activeSort.label}
                    <Box
                        component="span"
                        sx={{
                            display: "block",
                            width: "7px",
                            height: "7px",
                            borderRight: "1.6px solid #1A1A1A",
                            borderBottom: "1.6px solid #1A1A1A",
                            transform: "rotate(45deg) translateY(-2px)",
                        }}
                    />
                </Box>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                    {SORT_OPTIONS.map((option) => (
                        <MenuItem key={option.value} selected={option.value === activeSort.value} onClick={() => pick(option.value)}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Menu>
            </Box>
        </Container>
    );
};


FeedToolbar.propTypes = {
    total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sort: PropTypes.string,
    category: PropTypes.string,
    onSortChange: PropTypes.func.isRequired,
    onClearCategory: PropTypes.func.isRequired,
};

export default FeedToolbar;
